var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.52122 11.6971L0.321219 6.49706C0.00881243 6.18465 0.00881243 5.67812 0.321219 5.36568L1.45256 4.23431C1.76497 3.92187 2.27153 3.92187 2.58394 4.23431L6.08691 7.73725L13.5899 0.234305C13.9023 -0.0781016 14.4089 -0.0781016 14.7213 0.234305L15.8526 1.36568C16.165 1.67809 16.165 2.18462 15.8526 2.49706L6.6526 11.6971C6.34016 12.0095 5.83363 12.0095 5.52122 11.6971Z",
    fill: "#878787"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGrey);
export default __webpack_public_path__ + "static/media/tick-grey.96bb19636741fb6e0d3c9319a46dbf8a.svg";
export { ForwardRef as ReactComponent };